export const toErrorMessage = (err: unknown): string => (err instanceof Error ? err.message : String(err));
